import { createAction, props } from '@ngrx/store';

export const setCustomerNrcStatus = createAction(
  '[Customer] Set NRC Status',
  props<{ customerNrcStatus: any }>(),
);
export const setCustomerPage = createAction(
  '[Customer] Set Page',
  props<{ customerPage: any }>(),
);
